module.exports = __webpack_public_path__ + "assets/6c30dc286a153c961d42b057c2423b104.jpg";